import { m } from "@vega-core/paraglide/messages";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

import { DownloadToggle } from "./DownloadToggle";
import { TriStateCheckbox } from "./TriStateCheckbox";
import type { TriState } from "./types";

export const DOWNLOAD_COLUMN_WIDTH = 90;
export const ALL_COLUMN_BORDER_RIGHT_WIDTH = 1;

type DataRoomRowBulkActionsProps = {
  nodeId: string;
  nodeName: string;
  isFolder: boolean;
  treeColumnWidth: number;
  isDownloadable: boolean;
  onToggleDownload?: () => void;
  rowTriState: TriState;
  onRowToggle?: () => void;
};

export function DataRoomRowBulkActions({
  nodeId,
  nodeName,
  isFolder,
  treeColumnWidth,
  isDownloadable,
  onToggleDownload,
  rowTriState,
  onRowToggle,
}: DataRoomRowBulkActionsProps) {
  const rowBg = isFolder ? "bg-background/secondary" : "bg-background/primary";

  return (
    <>
      <td
        className={cnTwMerge(
          "md:sticky md:z-40 h-9 border-b border-border/primary",
          rowBg,
        )}
        data-testid={`cell-download-${nodeId}`}
        style={{ left: treeColumnWidth }}
      >
        <div className="flex h-full items-center justify-center">
          <DownloadToggle
            dataTestId={`download-toggle-${nodeId}`}
            isDownloadable={isDownloadable}
            onChange={onToggleDownload}
          />
        </div>
      </td>
      <td
        className={cnTwMerge(
          "md:sticky md:z-40 h-9 border-b border-border/primary",
          rowBg,
        )}
        data-testid={`cell-all-${nodeId}`}
        style={{
          left: treeColumnWidth + DOWNLOAD_COLUMN_WIDTH,
          borderRightWidth: ALL_COLUMN_BORDER_RIGHT_WIDTH,
        }}
      >
        <div className="flex h-full items-center justify-center">
          {onRowToggle !== undefined && (
            <TriStateCheckbox
              ariaLabel={m.coInvestments_dataRoom_toggleRow({ name: nodeName })}
              dataTestId={`checkbox-all-${nodeId}`}
              onChange={onRowToggle}
              state={rowTriState}
            />
          )}
        </div>
      </td>
    </>
  );
}
